import { Box } from '@mui/material';
import React from 'react';
import { useTranslation } from 'react-i18next';

import { useScope } from '@sophocles/app';
import AppNav from '@sophocles/components/App/AppNav';
import TitleBar from '@sophocles/components/App/TitleBar';

import FixtureReportGrid from './components/FixtureReportGrid';

function FixtureReportView(props) {
  const { t } = useTranslation();
  const {
    match: { params },
  } = props;

  const { customer, siteGroup } = useScope();
  const isBillboard = customer?.is_billboard ?? true;
  const baseStructureLink = `/c/${params.cust_id}/plant/${params.sitegroup_id}/structure/`;

  return (
    <AppNav flex notFullHeight page="plant" {...props}>
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',
          flex: 1,
          overflow: 'hidden',
          padding: '0 var(--page-px) var(--page-py)',
        }}
      >
        <TitleBar showBackButton title={t('reports.fixtureReport')} />
        <FixtureReportGrid
          baseStructureLink={baseStructureLink}
          isBillboard={isBillboard}
          siteGroupId={siteGroup?.id}
          siteGroup={siteGroup}
        />
      </Box>
    </AppNav>
  );
}

export default FixtureReportView;
